import { inferIconFromType, getNodeType } from "./nodeRegistry";

const TRIGGER_TYPE_TO_ICON = {
    WEBHOOK: "webhook",
    TIME: "schedule",
    EMAIL: "email",
    WHATSAPP: "whatsapp",
    API: "webhook",
    EVENT: "webhook",
};

const TRIGGER_TYPE_TO_LABEL = {
    WEBHOOK: "Webhook Trigger",
    TIME: "Schedule Trigger",
    EMAIL: "Email Trigger",
    WHATSAPP: "WhatsApp Trigger",
    API: "API Trigger",
    EVENT: "Event Trigger",
    TOOL: "Tool Trigger",
    APP: "App Trigger",
};

export function triggerToNode(trigger) {
    const iconKey = TRIGGER_TYPE_TO_ICON[trigger.type] || "trigger";
    const label = TRIGGER_TYPE_TO_LABEL[trigger.type] || "Trigger";

    return {
        id: `trigger-${trigger.id}`,
        type: "trigger",
        position: { x: 0, y: 0 },
        data: {
            icon: iconKey,
            title: label,
            label,
            triggerType: trigger.type,
            publicKey: trigger.publicKey,
            timeConfig: trigger.timeConfig || null,
            whatsappNumber: trigger.whatsappTrigger?.whatsappNumber?.number || null,
            allowedPhones: trigger.whatsappTrigger?.allowedPhones || [],
        },
    };
}

export function stepToNode(step, executionData) {
    const meta = step.config?.nodeMetadata || {};
    const iconKey = meta.icon || inferIconFromType(step);

    return {
        id: step.id,
        type: getNodeType(step),
        position: step.config?.canvasPosition || { x: 0, y: 0 },
        data: {
            icon: iconKey,
            title: step.name,
            subtitle: meta.subtitle || "",
            notes: meta.notes || "",
            label: step.name,
            description: step.description,
            stepType: step.type,
            code: step.config?.code,
            parameters: step.config?.parameters,
            integrationName: step.config?.integrationName,
            order: step.order,
            execution: executionData || null,
        },
    };
}

export function buildNodesAndEdges(triggers, steps) {
    const triggerNodes = (triggers || []).map(triggerToNode);
    const sorted = [...steps].sort((a, b) => a.order - b.order);
    const stepNodes = sorted.map((s) => stepToNode(s));
    const allNodes = [...triggerNodes, ...stepNodes];

    const edges = [];

    // Connect each trigger to the first step
    if (sorted.length > 0) {
        triggerNodes.forEach((tNode) => {
            edges.push({
                id: `e-${tNode.id}-${sorted[0].id}`,
                source: tNode.id,
                target: sorted[0].id,
                type: "dataFlow",
                data: { status: "default" },
            });
        });
    }

    // Connect steps sequentially
    for (let i = 0; i < sorted.length - 1; i++) {
        edges.push({
            id: `e-${sorted[i].id}-${sorted[i + 1].id}`,
            source: sorted[i].id,
            target: sorted[i + 1].id,
            type: "dataFlow",
            data: { status: "default" },
        });
    }

    return { nodes: allNodes, edges };
}
